export const TRANSLATIONS_VERSION = 'aadd8a41092a3b4b11089ca8ed4d4fb8b94133331e95bfa15232af5c58ea514a'
